
export const productionGrainsHeaderElements = [
  { label: "Grano", value: "nombre" },
  { label: "Aplica PP y MB", value: "aplicaPPMB" },
  { label: "Grano ADMIS", value: "granoAdmis" },
  { label: "Suma HA", value: "sumaHA" },
];

